import o from "clsx";
import e from "react";
import { s as n } from "../../../../../RideFullIcon.module-B-94u-qz.mjs";
function p({
  size: t = "small",
  accessibilityTitle: C = "full icon send info light",
  className: l,
  "data-testid": r
}) {
  const a = () => o(l, n["ride-full-icon"], {
    [n[`size-${t}`]]: t
  });
  return /* @__PURE__ */ e.createElement("div", { className: a(), "data-testid": r }, /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "72",
      height: "72",
      viewBox: "0 0 72 72",
      fill: "none",
      stroke: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    C && /* @__PURE__ */ e.createElement("title", null, C),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M67.4466 4.63214C67.156 4.33373 66.7895 4.12025 66.3866 4.01469C65.9837 3.90913 65.5596 3.91548 65.16 4.03308L21.4875 16.844C20.6473 17.0901 19.8894 17.559 19.2941 18.2009C18.6988 18.8428 18.2883 19.6339 18.1061 20.4901C17.9238 21.3464 17.9767 22.2361 18.2591 23.0648C18.5415 23.8934 19.0428 24.6303 19.71 25.1971L28.4063 32.5884L29.5313 46.994C29.5505 47.2139 29.6339 47.4232 29.7713 47.596C29.9086 47.7688 30.0937 47.8974 30.3036 47.9657C30.5134 48.0341 30.7387 48.0392 30.9515 47.9804C31.1642 47.9217 31.355 47.8016 31.5 47.6353L37.6312 40.4409L39.7688 42.2578L41.2031 40.5225L36.1069 36.194L65.7337 6.5812L53.5134 44.5499C53.3347 45.1028 53.0225 45.6031 52.6046 46.0067C52.1866 46.4104 51.6757 46.7048 51.1169 46.8641C50.5581 47.0234 49.9687 47.0426 49.4007 46.9201C48.8328 46.7975 48.3037 46.537 47.8603 46.1615L47.0166 45.4303L45.5822 47.1656L46.4259 47.8743C47.1507 48.4905 48.0163 48.9184 48.946 49.1199C49.8757 49.3215 50.8408 49.2906 51.7557 49.03C52.6706 48.7693 53.5071 48.287 54.191 47.6257C54.8749 46.9644 55.385 46.1446 55.6763 45.239L67.9866 6.93277C68.114 6.5364 68.131 6.11282 68.0359 5.7075C67.9408 5.30218 67.737 4.93042 67.4466 4.63214ZM29.25 30.3496L21.1725 23.4815C20.8152 23.1776 20.5466 22.7828 20.3953 22.3388C20.244 21.8948 20.2156 21.4182 20.313 20.9594C20.4104 20.5005 20.6301 20.0766 20.9487 19.7324C21.2674 19.3882 21.6732 19.1365 22.1231 19.004L63.8438 6.76683L29.25 30.3496Z",
        fill: "url(#paint0_linear_4234_1569)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M9.94502 63.197C9.94026 61.925 10.1879 60.6648 10.6736 59.4893C11.1592 58.3137 11.8733 57.2462 12.7744 56.3485C13.8494 55.2603 15.1627 54.4371 16.6106 53.9438C17.0444 51.9705 17.9453 50.1302 19.2378 48.5773C20.5303 47.0244 22.1767 45.8044 24.0385 45.0198L25.1325 47.6101C23.8686 48.1478 22.7312 48.9441 21.7934 49.9477C20.8557 50.9513 20.1383 52.1401 19.6875 53.4376H20.866C21.7618 53.442 22.6363 53.712 23.3788 54.2133C24.1213 54.7146 24.6985 55.4248 25.0375 56.2541C25.3765 57.0833 25.462 57.9945 25.2833 58.8724C25.1046 59.7503 24.6696 60.5555 24.0333 61.1862C23.3971 61.8169 22.5882 62.2449 21.7088 62.416C20.8294 62.5871 19.919 62.4937 19.0927 62.1475C18.2664 61.8013 17.5612 61.2179 17.0664 60.4711C16.5715 59.7243 16.3092 58.8475 16.3125 57.9516V57.1473C15.7455 57.4698 15.2251 57.8682 14.7656 58.3313C14.1259 58.9677 13.6188 59.7247 13.2736 60.5585C12.9284 61.3922 12.7521 62.2862 12.7547 63.1885L9.94502 63.197ZM19.125 56.2641C19.125 56.402 19.125 56.5454 19.125 56.6748V57.9516C19.1239 58.2929 19.2241 58.6268 19.4128 58.911C19.6016 59.1953 19.8705 59.4171 20.1854 59.5485C20.5003 59.6798 20.8472 59.7148 21.182 59.6489C21.5168 59.583 21.8245 59.4192 22.0662 59.1784C22.3079 58.9375 22.4726 58.6303 22.5396 58.2957C22.6066 57.9611 22.5728 57.6142 22.4424 57.2988C22.3121 56.9834 22.0911 56.7138 21.8075 56.5242C21.5239 56.3345 21.1903 56.2332 20.8491 56.2332H19.7719C19.5581 56.2501 19.3472 56.2501 19.125 56.2641ZM12.7463 66.0038H9.93378V69.7501H12.7463V66.0038ZM42.961 41.9316L35.8031 50.5998L38.1882 52.5685L45.3572 43.9004L42.961 41.9316ZM44.6485 49.1626L40.3453 54.3629L42.7303 56.3316L47.0306 51.1313L44.6485 49.1626Z",
        fill: "url(#paint1_linear_4234_1569)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint0_linear_4234_1569",
        x1: "17.9998",
        y1: "3.93994",
        x2: "40.6498",
        y2: "60.2846",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { offset: "0.272135", stopColor: "#34263B" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "0.658079", stopColor: "#13172C" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint1_linear_4234_1569",
        x1: "9.93378",
        y1: "69.7501",
        x2: "35.7145",
        y2: "33.8135",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { offset: "0.00520833", stopColor: "#F93757" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#FB8296" })
    ))
  ));
}
export {
  p as RideFiSendInfoLight
};
